<template>
    <div>
        <h1 style="font-size: 24px; color: black;">APP广告ID配置</h1>
        <el-row>
            <el-col>
                <el-button type="primary" @click="showSaveFormDialog('新增应用')">新增应用</el-button>
            </el-col>
        </el-row>
        <el-col :span="10">
            <span>渠道</span>
            <el-cascader v-model="queryData.subChannels" :options="subChannels" :props="optionProps" clearable
                         collapse-tags>
            </el-cascader>
            <span>app应用</span>
            <el-select v-model="queryData.appIds" placeholder="请选择" multiple>
                <el-option
                    v-for="item in apps"
                    :key="item.appId"
                    :label="item.appName"
                    :value="item.appId">
                </el-option>
            </el-select>
        </el-col>
        <el-button type="primary" @click="getList">查询</el-button>
        <h1>
            <el-table border :data="list">
                <el-table-column prop="id" label="编号" align="center"></el-table-column>
                <el-table-column prop="appId" label="应用" align="center" :formatter="appFormatter"></el-table-column>
                <el-table-column label="渠道" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.subChannels.length === 0 ? "" : scope.row.subChannels.join(",") }}
                    </template>
                </el-table-column>
                <el-table-column prop="plates" label="聚合" align="center"
                                 :formatter="adPlateFormatter"></el-table-column>
                <el-table-column prop="remark" label="备注" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showSaveFormDialog('编辑配置',scope.row)">编辑</el-button>
                        <el-button type="text" @click="remove(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </h1>

        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="800px">
            <el-form :model="saveForm">
                <el-form-item label="应用名称" :label-width="labelWidth">
                    <el-select v-model="saveForm.appId">
                        <el-option
                            v-for="item in apps"
                            :key="item.appId"
                            :label="item.appName"
                            :value="item.appId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="渠道" :label-width="labelWidth">
                    <el-cascader v-model="saveForm.subChannels" :options="subChannels" :props="optionProps" clearable
                                 collapse-tags>
                    </el-cascader>
                </el-form-item>
                <el-form-item label="备注" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.remark"></el-input>
                </el-form-item>
                <el-form-item label="增长参谋ID" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.growthStaffId"></el-input>
                </el-form-item>
                <el-form-item label="topOnAppKey" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.topOnAppKey"></el-input>
                </el-form-item>
                <hr>
                <el-form-item label="选择聚合SDK" :label-width="labelWidth">
                    <el-select v-model="savePlate.adPlate" @change="change">
                        <el-option
                            v-for="item in adPlates"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">如果修改了切换之前需要保存</span>
                </el-form-item>
                <el-form-item label="比例" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.rate"></el-input>
                    <span style="color: red">如果全部是0，那就是平权</span>
                </el-form-item>
                <el-form-item label="聚合APPID" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.adAppId"></el-input>
                </el-form-item>
                <el-form-item label="安装后首次开屏" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.firstSplashAd"></el-input>
                </el-form-item>
                <el-form-item label="开屏" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.splashAd"></el-input>
                </el-form-item>
                <el-form-item label="激励视频" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.rewardAd"></el-input>
                </el-form-item>
                <el-form-item label="激励视频横" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.rewardAdHor"></el-input>
                </el-form-item>
                <el-form-item label="开屏后首次插屏" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.insertAdAfterSplash"></el-input>
                </el-form-item>
                <el-form-item label="游戏加载后插屏" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.insertAdGamaLoadSuccess"></el-input>
                </el-form-item>
                <el-form-item label="游戏加载后插屏横" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.insertAdGamaLoadSuccessHor"></el-input>
                </el-form-item>
                <el-form-item label="关卡插屏" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.insertAdGameCheckPoint"></el-input>
                </el-form-item>
                <el-form-item label="关卡插屏横" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.insertAdGameCheckPointHor"></el-input>
                </el-form-item>
                <el-form-item label="关闭广告后插屏" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.insertAdAfterGameReward"></el-input>
                </el-form-item>
                <el-form-item label="关闭广告后插屏横" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.insertAdAfterGameRewardHor"></el-input>
                </el-form-item>
                <el-form-item label="广场信息流" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.nativeAdForumSquare"></el-input>
                </el-form-item>
                <el-form-item label="聊天室信息流" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.nativeAdChatRoom"></el-input>
                </el-form-item>
                <el-form-item label="游戏加载页信息流" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.nativeAdGameLoading"></el-input>
                </el-form-item>
                <el-form-item label="发现页信息流" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.nativeAdFindPage"></el-input>
                </el-form-item>
                <el-form-item label="首页信息流广告位" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.nativeAdFindPage2"></el-input>
                </el-form-item>
                <el-form-item label="聊天室相册解锁广告位" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.rewardAdChatRoomPic"></el-input>
                </el-form-item>
                <el-form-item label="搜索中间页信息流广告位" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.nativeAdSearchPage2"></el-input>
                </el-form-item>
                <el-form-item label="横幅信息流" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.nativeAdDialogBottom"></el-input>
                </el-form-item>
                <el-form-item label="退出游戏页信息流" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.nativeAdGameExitDialog"></el-input>
                </el-form-item>
                <el-form-item label="搜索页信息流" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.nativeAdSearchPage"></el-input>
                </el-form-item>
                <el-form-item label="游戏内banner" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.bannerAdGameRunning"></el-input>
                </el-form-item>
                <el-form-item label="全屏视频插屏" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.fullScreenVideoInsertion"></el-input>
                </el-form-item>
                <el-form-item label="全屏视频插屏横" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.fullScreenVideoInsertionHor"></el-input>
                </el-form-item>
                <el-form-item label="激励视频白包专用" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.whiteRewardAd"></el-input>
                </el-form-item>
                <el-form-item label="插屏白包专用" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.whiteInsertAd"></el-input>
                </el-form-item>
                <el-form-item label="开屏白包专用" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.whiteSplashAd"></el-input>
                </el-form-item>
                <el-form-item label="信息流白包专用" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.whiteNativeAd"></el-input>
                </el-form-item>
                <el-form-item label="打开APP插屏" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.insertAdAppStart"></el-input>
                </el-form-item>
                <el-form-item label="主页切换插屏" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.insertAdMainTabSwitch"></el-input>
                </el-form-item>
                <el-form-item label="退出游戏插屏竖" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.insertAdExitGame"></el-input>
                </el-form-item>
                <el-form-item label="退出游戏插屏横" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.insertAdExitGameHor"></el-input>
                </el-form-item>
                <el-form-item label="游戏中插屏竖" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.insertAdGameProcess"></el-input>
                </el-form-item>
                <el-form-item label="游戏中插屏横" :label-width="labelWidth">
                    <el-input type="text" v-model="savePlate.insertAdGameProcessHor"></el-input>
                </el-form-item>


            </el-form>
            <div style="text-align: center;">
                <el-button type="primary" @click="confirmForm">提 交</el-button>
                <el-button type="info" @click="dialogVisible=false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {adPlateEnum, appAll, channelList, removeAdId, saveAdId, searchAdId} from '@/http/api'
import app from "@/App.vue";

export default {
    name: "AdId",
    computed: {
        app() {
            return app
        }
    },
    data() {
        return {
            dialogVisible: false,
            dialogTitle: '',
            labelWidth: '110px',
            list: [],
            subChannels: [],
            apps: [],
            adPlates: [],
            optionProps: {
                emitPath: false,
                multiple: true,
                value: 'subChannel',
                label: 'name',
                children: 'children',
            },
            saveForm: {
                id: null,
                appId: null,
                subChannels: [],
                growthStaffId: null,
                topOnAppKey: null,
                remark: null
            },
            savePlate: {
                rate:null,
                plateId: null,
                adAppId: null,
                adPlate: null,
                firstSplashAd: null,
                splashAd: null,
                rewardAd: null,
                rewardAdHor: null,
                insertAdAfterSplash: null,
                insertAdGamaLoadSuccess: null,
                insertAdGamaLoadSuccessHor: null,
                insertAdGameCheckPoint: null,
                insertAdGameCheckPointHor: null,
                insertAdAfterGameReward: null,
                insertAdAfterGameRewardHor: null,
                nativeAdForumSquare: null,
                nativeAdChatRoom: null,
                nativeAdGameLoading: null,
                nativeAdFindPage: null,
                nativeAdDialogBottom: null,
                nativeAdGameExitDialog: null,
                nativeAdSearchPage: null,
                bannerAdGameRunning: null,
                fullScreenVideoInsertion: null,
                fullScreenVideoInsertionHor: null,
                whiteRewardAd: null,
                whiteInsertAd: null,
                whiteSplashAd: null,
                whiteNativeAd: null,
                insertAdAppStart: null,
                insertAdMainTabSwitch: null,
                insertAdExitGame: null,
                insertAdExitGameHor: null,
                insertAdGameProcess: null,
                insertAdGameProcessHor: null,
                nativeAdFindPage2:null,
                rewardAdChatRoomPic:null,
                nativeAdSearchPage2:null
            },
            page: {
                size: 10,
                page: 1,
                totalElements: null
            },
            queryData: {},
        }
    },
    methods: {
        change(row) {
            console.log(this.saveForm)
            var _data = this.saveForm.plates[row];
            if (_data == null) {
                _data = new Object();
            }
            this.savePlate = {
                plateId: _data.id,
                adAppId: _data.adAppId,
                adPlate: row,
                firstSplashAd: _data.firstSplashAd,
                rate: _data.rate,
                splashAd: _data.splashAd,
                rewardAd: _data.rewardAd,
                rewardAdHor: _data.rewardAdHor,
                insertAdAfterSplash: _data.insertAdAfterSplash,
                insertAdGamaLoadSuccess: _data.insertAdGamaLoadSuccess,
                insertAdGamaLoadSuccessHor: _data.insertAdGamaLoadSuccessHor,
                insertAdGameCheckPoint: _data.insertAdGameCheckPoint,
                insertAdGameCheckPointHor: _data.insertAdGameCheckPointHor,
                insertAdAfterGameReward: _data.insertAdAfterGameReward,
                insertAdAfterGameRewardHor: _data.insertAdAfterGameRewardHor,
                nativeAdForumSquare: _data.nativeAdForumSquare,
                nativeAdChatRoom: _data.nativeAdChatRoom,
                nativeAdGameLoading: _data.nativeAdGameLoading,
                nativeAdFindPage: _data.nativeAdFindPage,
                nativeAdDialogBottom: _data.nativeAdDialogBottom,
                nativeAdGameExitDialog: _data.nativeAdGameExitDialog,
                nativeAdSearchPage: _data.nativeAdSearchPage,
                bannerAdGameRunning: _data.bannerAdGameRunning,
                fullScreenVideoInsertion: _data.fullScreenVideoInsertion,
                fullScreenVideoInsertionHor: _data.fullScreenVideoInsertion,
                whiteRewardAd: _data.whiteRewardAd,
                whiteInsertAd: _data.whiteInsertAd,
                whiteSplashAd: _data.whiteSplashAd,
                whiteNativeAd: _data.whiteNativeAd,
                insertAdAppStart: _data.insertAdAppStart,
                insertAdMainTabSwitch: _data.insertAdMainTabSwitch,
                insertAdExitGame: _data.insertAdExitGame,
                insertAdExitGameHor: _data.insertAdExitGameHor,
                insertAdGameProcess: _data.insertAdGameProcess,
                insertAdGameProcessHor: _data.insertAdGameProcessHor,
                nativeAdFindPage2:_data.nativeAdFindPage2,
                rewardAdChatRoomPic:_data.rewardAdChatRoomPic,
                nativeAdSearchPage2:_data.nativeAdSearchPage2,
            }
        },
        appFormatter: function (row, column, cellValue) {
            let temp = ""
            this.apps.forEach(item => {
                if (item.appId === cellValue) {
                    temp = item.appName;
                }
            })
            return temp
        },
        adPlateFormatter: function (row, column, cellValue) {
            let temp = ""
            for (var x in cellValue) {
                this.adPlates.forEach(item => {
                    if (item.id == x) {
                        temp += item.name + " ";
                    }
                })
            }
            return temp
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.getList();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.getList();
        },
        getList() {
            this.queryData.size = this.page.size;
            this.queryData.page = this.page.page;
            searchAdId(this.queryData).then(resp => {
                this.list = resp.data.info.list;
                this.page.totalElements = resp.data.info.totalElements;
            });
        },
        remove(id) {
            this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeAdId(id).then(resp => {
                    if (resp.data.status === 0) {
                        this.getList();
                    }
                });
            }).catch(() => {
            })
        },
        showSaveFormDialog(_title, _data) {
            this.dialogVisible = true;
            this.dialogTitle = _title;
            this.saveForm = {
                id: null,
                appId: null,
                subChannels: [],
                growthStaffId: null,
                topOnAppKey: null,
                remark: null
            };
            this.savePlate = {
                adPlate: null,
                adAppId: null,
                plateId: null,
                rate: null,
                firstSplashAd: null,
                splashAd: null,
                rewardAd: null,
                rewardAdHor: null,
                insertAdAfterSplash: null,
                insertAdGamaLoadSuccess: null,
                insertAdGamaLoadSuccessHor: null,
                insertAdGameCheckPoint: null,
                insertAdGameCheckPointHor: null,
                insertAdAfterGameReward: null,
                insertAdAfterGameRewardHor: null,
                nativeAdForumSquare: null,
                nativeAdChatRoom: null,
                nativeAdGameLoading: null,
                nativeAdFindPage: null,
                nativeAdDialogBottom: null,
                nativeAdGameExitDialog: null,
                nativeAdSearchPage: null,
                bannerAdGameRunning: null,
                fullScreenVideoInsertion: null,
                fullScreenVideoInsertionHor: null,
                whiteRewardAd: null,
                whiteInsertAd: null,
                whiteSplashAd: null,
                whiteNativeAd: null,
                insertAdAppStart: null,
                insertAdMainTabSwitch: null,
                insertAdExitGame: null,
                insertAdExitGameHor: null,
                insertAdGameProcess: null,
                insertAdGameProcessHor: null,
                nativeAdFindPage2:null,
                rewardAdChatRoomPic:null,
                nativeAdSearchPage2:null
            }
            if (_data) {
                this.saveForm = {
                    id: _data.id,
                    appId: _data.appId,
                    subChannels: _data.subChannels,
                    growthStaffId: _data.growthStaffId,
                    topOnAppKey: _data.topOnAppKey,
                    plates: _data.plates,
                    remark: _data.remark
                }
                var plate;
                var adPlate;
                for (var x in _data.plates) {
                    plate = _data.plates[x];
                    adPlate = parseInt(x);
                }
                _data = plate;
                this.savePlate = {
                    adAppId: _data.adAppId,
                    plateId: _data.id,
                    adPlate: adPlate,
                    firstSplashAd: _data.firstSplashAd,
                    splashAd: _data.splashAd,
                    rate: _data.rate,
                    rewardAd: _data.rewardAd,
                    rewardAdHor: _data.rewardAdHor,
                    insertAdAfterSplash: _data.insertAdAfterSplash,
                    insertAdGamaLoadSuccess: _data.insertAdGamaLoadSuccess,
                    insertAdGamaLoadSuccessHor: _data.insertAdGamaLoadSuccessHor,
                    insertAdGameCheckPoint: _data.insertAdGameCheckPoint,
                    insertAdGameCheckPointHor: _data.insertAdGameCheckPointHor,
                    insertAdAfterGameReward: _data.insertAdAfterGameReward,
                    insertAdAfterGameRewardHor: _data.insertAdAfterGameRewardHor,
                    nativeAdForumSquare: _data.nativeAdForumSquare,
                    nativeAdChatRoom: _data.nativeAdChatRoom,
                    nativeAdGameLoading: _data.nativeAdGameLoading,
                    nativeAdFindPage: _data.nativeAdFindPage,
                    nativeAdDialogBottom: _data.nativeAdDialogBottom,
                    nativeAdGameExitDialog: _data.nativeAdGameExitDialog,
                    nativeAdSearchPage: _data.nativeAdSearchPage,
                    bannerAdGameRunning: _data.bannerAdGameRunning,
                    fullScreenVideoInsertion: _data.fullScreenVideoInsertion,
                    fullScreenVideoInsertionHor: _data.fullScreenVideoInsertion,
                    whiteRewardAd: _data.whiteRewardAd,
                    whiteInsertAd: _data.whiteInsertAd,
                    whiteSplashAd: _data.whiteSplashAd,
                    whiteNativeAd: _data.whiteNativeAd,
                    insertAdAppStart: _data.insertAdAppStart,
                    insertAdMainTabSwitch: _data.insertAdMainTabSwitch,
                    insertAdExitGame: _data.insertAdExitGame,
                    insertAdExitGameHor: _data.insertAdExitGameHor,
                    insertAdGameProcess: _data.insertAdGameProcess,
                    insertAdGameProcessHor: _data.insertAdGameProcessHor,
                    nativeAdFindPage2:_data.nativeAdFindPage2,
                    rewardAdChatRoomPic:_data.rewardAdChatRoomPic,
                    nativeAdSearchPage2:_data.nativeAdSearchPage2,
                }
            }
        },
        confirmForm() {
            let _message = '';
            if (this.saveForm.subChannels.length < 1) {
                _message = '渠道必选'
            } else if (this.saveForm.appId === null) {
                _message = '应用必选'
            } else if (this.saveForm.adPlate === null) {
                _message = '聚合SDK必选'
            } else if (this.saveForm.remark === null) {
                _message = '备注必填'
            }
            if (_message) {
                this.$message({
                    message: _message,
                    type: 'error'
                });
                return;
            }
            saveAdId({...this.saveForm, ...this.savePlate}).then(resp => {
                if (resp.data.status === 0) {
                    this.getList();
                    this.dialogVisible = false;
                }
            });
        }

    },
    created() {
        this.getList();
        let _this = this;
        channelList().then(resp => {
            this.subChannels = JSON.parse(JSON.stringify(resp.data.info)).map(channel => {
                if (channel.children) {
                    channel.children = channel.children.filter(sub => sub.state === 1)
                }
                return channel;
            }).filter(channel => channel.children && channel.children.length);
            this.subChannels.forEach(function (channel) {
                _this.$set(channel, 'subChannel', channel.id);
            });
            appAll().then(resp => {
                this.apps = resp.data.info;
            });
            adPlateEnum().then(resp => {
                this.adPlates = resp.data.info.filter(item => item.id === 205 || item.id === 208 || item.id === 203);
            });
        });
    }
}
</script>

<style scoped>

</style>
